export default __webpack_public_path__ + "static/social-feminicidio-9c88a7e08e27aa386414786fda3a7b8e.png";